import { styled, alpha } from "@mui/material/styles";
import {
  AppBar as MuiAppBar,
  Container as MuiContainer,
} from "@mui/material";
import Link from "next/link"

export const HeaderContainer = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "flex-start",
  flex: 2,
  gap: theme.space._600
}));

export const LinksContainer = styled("div")(({ theme }) => ({
  display: "none",
  flexGrow: 1,
  "@media (min-width: 900px)": {
    display: "flex",
  },
}));

export const ChildrenContainer = styled("div")(({ theme }) => ({
  flexGrow: 1,
  alignSelf:'center',
  display: 'flex',
  justifyContent: "center",
  flex: 1
}));

export const LogoLink = styled(Link)(({ theme }) => ({
  display: "flex",
  color: theme.colors["neutral.50"]
}));

export const CtaWrapper = styled("div")(({ theme }) => ({
  display: "flex",
}));

export const ShowMobile = styled("div")(({ theme }) => ({
  display: "none",
  
  "@media (max-width: 600px)": {
    display: "flex",
  },
}));

export const HideMobile = styled("div")(({ theme }) => ({
  display: "flex",

  "@media (max-width: 600px)": {
    display: "none",
  },
}));

export const NavigationBarContainer = styled(MuiContainer)(({ theme }) => ({
  maxWidth: "1440px",
  padding: `0 ${theme.space._700}`,
  
  "@media (max-width: 600px)": {
    padding: `0 ${theme.space._400}`,
  },
}));

export const CustomNavigationBar = styled(MuiAppBar)(({ theme }) => ({
  position: "absolute",
  overflowX: "hidden",
  width: "calc(100vw - 15px)",
  zIndex: 1,
  top: 0,
  padding: `${theme.space._400} 0`,
  background: `
    linear-gradient(180deg, 
      ${alpha(theme.colors["neutral.950"], 0.75)} 0%, 
      ${alpha(theme.colors["neutral.950"], 0.6)} 60.81%, 
      ${alpha(theme.colors["neutral.950"], 0)} 100%)
    `,
  boxShadow: "none",
}));